module.exports = __webpack_public_path__ + "static/media/photo-10.4ee32792.jpg";